module.exports = __webpack_public_path__ + "static/img/img_gy_al_cc.b067154d.png";